import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IPublishRequestPayload {
    id: string
    data: {
        publishAll?: boolean
        companies?: string[]
    }
}

export interface ICreateState {
    status: string
    data: null
    errors: any
}

const initialState: ICreateState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const publishListSlice = createSlice({
    name: 'hub/editList/publish',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IPublishRequestPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const publishListActions = publishListSlice.actions
export default publishListSlice.reducer
